<ng-container *ngIf="rtConsoleState$ | async as rtConsole">
  <div
    *ngIf="rtConsole.showConsole"
    class="rt-console"
    [class.rt-console--inactive]="!rtConsole.isActive"
    [class.rt-console--unavailable]="rtConsole.isUnavailable"
    [class.rt-console--stopping]="rtConsole.isStopping">
    <ng-container *ngIf="rtConsole.isActive; else inactiveState">
      <div class="rt-console__status">
        <span
          class="rt-console__dot"
          [class.rt-console__dot--stopping]="rtConsole.isStopping">
        </span>
        <span class="rt-console__label">{{ labels.title }}</span>
      </div>

      <div class="rt-console__info">
        <span
          *ngIf="rtConsole.lastDataSecondsAgo !== null"
          class="rt-console__last">
          {{ labels.last }}: {{ rtConsole.lastDataSecondsAgo }}s {{ labels.ago }}
        </span>
        <span
          *ngIf="rtConsole.isStopping"
          class="rt-console__countdown rt-console__countdown--stopping">
          {{ labels.stopping }}
        </span>
        <span
          *ngIf="!rtConsole.isStopping && rtConsole.countdownSeconds !== null"
          class="rt-console__countdown">
          {{ labels.stopIn }} {{ rtConsole.countdownSeconds }}s
        </span>
      </div>

      <div class="rt-console__actions">
        <button
          type="button"
          class="rt-console__btn rt-console__btn--toggle"
          (click)="onToggleOverlay(rtConsole.overlayVisible)"
          [attr.aria-label]="rtConsole.overlayVisible ? labels.hide : labels.show">
          <ion-icon
            [name]="rtConsole.overlayVisible ? 'eye-off-outline' : 'eye-outline'"
            class="rt-console__icon">
          </ion-icon>
        </button>
        <button
          type="button"
          class="rt-console__btn rt-console__btn--stop"
          (click)="onStop()"
          [disabled]="rtConsole.isStopping"
          [attr.aria-label]="labels.stop">
          <ion-icon
            name="stop-circle-outline"
            class="rt-console__icon">
          </ion-icon>
        </button>
      </div>
    </ng-container>

    <ng-template #inactiveState>
      <div class="rt-console__status rt-console__status--inactive">
        <span
          class="rt-console__dot rt-console__dot--inactive"
          [class.rt-console__dot--unavailable]="rtConsole.isUnavailable">
        </span>
        <span class="rt-console__label">{{ labels.title }}</span>
      </div>
      <div class="rt-console__actions">
        <button
          type="button"
          class="rt-console__btn rt-console__btn--start"
          [disabled]="!rtConsole.canUseRealTime"
          (click)="onStart()"
          [attr.aria-label]="labels.start">
          <ion-icon
            name="play-circle-outline"
            class="rt-console__icon">
          </ion-icon>
          <span class="rt-console__btn-label">{{ labels.start }}</span>
        </button>
        <button
          *ngIf="rtConsole.unavailableReason !== null"
          type="button"
          class="rt-console__btn rt-console__btn--info"
          matTooltipPosition="above"
          matTooltipClass="body-2"
          [matTooltip]="rtConsole.unavailableReason === 'disconnected' ? labels.realtimeDisconnectedHint : labels.realtimeFirmwareHint"
          [attr.aria-label]="rtConsole.unavailableReason === 'disconnected' ? labels.realtimeDisconnectedHint : labels.realtimeFirmwareHint"
          [attr.title]="rtConsole.unavailableReason === 'disconnected' ? labels.realtimeDisconnectedHint : labels.realtimeFirmwareHint">
          <ion-icon
            name="information-circle-outline"
            class="rt-console__icon">
          </ion-icon>
        </button>
      </div>
    </ng-template>
  </div>
</ng-container>
